import { isString } from "lodash";

declare const jQuery: any;
const $ = jQuery;

export function galleryPopup(): void
{
    const $popups = $(".popup.popup-gallery");
    if ($popups.length === 0)
    {
        return;
    }
    $popups.each(function () {
        const $popup = $(this);
        initPopupSideInfo($popup);
        initPopupGallerySliderInitialImage($popup);
    });
}

function initPopupSideInfo($popup): void
{
    const $info = $popup.find(".info");
    $popup.find("[data-open-info]").on("click", function (event) {
        $info.addClass("show");
        return false;
    });
    $popup.find("[data-close-info]").on("click", function (event) {
        $info.css({ opacity: 0 });
        setTimeout(() => {
            $info.removeClass("show").css({ opacity: "" });
        }, 320);
        return false;
    });
}

// Slide to the correct item on popup open
function initPopupGallerySliderInitialImage($popup): void
{
    const $slider = $popup.find(`.slider`);
    if ($slider.length === 0)
    {
        return;
    }
    const $sliderImages = $slider.find(`.slider-item img[data-image-id]`);
    $popup.on("opening", (event, data) => {
        if (!data || !data.popupData || !isString(data.popupData))
        {
            return;
        }
        const imageId: number = parseInt(data.popupData.split(/\-/)[1], 10);
        if (!imageId)
        {
            return;
        }
        const itemIndex: number = $sliderImages.filter(`[data-image-id="${imageId}"]`).parent().index();
        if (!itemIndex || itemIndex < 0)
        {
            return;
        }
        $slider.trigger("slide-to-item", { itemIndex, noAnim: true });
    });
}
